const initialState = false;

const showCalendarTasksPanelReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_CALENDAR_TASKS_PANEL':
            return !state;
        default:
            return state;
    }
};

export default showCalendarTasksPanelReducer;
